import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Route } from '@angular/router';

import { redirectToV2Guard } from 'app/app-redirect-to-v2.guard';

@NgModule({
    declarations: [],
    imports: [CommonModule],
})
export class SmartInsightsModule {
    static defineRoute(path: string): Route {
        return {
            path,
            canActivate: [redirectToV2Guard],
            loadChildren: () =>
                import('app/smart-insights/smart-insights.lazy.module').then(
                    (m) => m.SmartInsightsLazyLoadedModule,
                ),
        };
    }
}
